(() => {
  function initKachingLensSync() {
    const kb = document.querySelector('kaching-bundles-block');
    if (!kb) {
      setTimeout(initKachingLensSync, 500);
      return;
    }
    function getSelectors() {
      const lensLink = kb.querySelector(
        'a[href*="/products/lens-protector-iphone-17-pro-promax"]'
      );
      if (!lensLink) return {};
      const lensProduct = lensLink.closest(
        '.kaching-bundles__bundle-products__product'
      );
      if (!lensProduct) return {};
      const bundleBar = lensProduct.closest('.kaching-bundles__bar');
      if (!bundleBar) return {};
      const products = [
        ...bundleBar.querySelectorAll(
          '.kaching-bundles__bundle-products__product'
        )
      ];
      const caseProduct = products.find(
        product =>
          product !== lensProduct &&
          product.querySelector('select[data-name="Phone"]')
      );
      const caseSelect = caseProduct?.querySelector(
        'select[data-name="Phone"]'
      );
      const lensSelect = lensProduct.querySelector(
        'select[data-name="Phone"]'
      );
      return { caseSelect, lensSelect };
    }
    function syncLensToCase() {
      const { caseSelect, lensSelect } = getSelectors();
      if (!caseSelect || !lensSelect) return;
      const caseModel =
        caseSelect.options[caseSelect.selectedIndex]?.text.trim();
      if (!caseModel) return;
      const matchingLensOption = [...lensSelect.options].find(
        option => option.text.trim() === caseModel
      );
      if (!matchingLensOption) return;
      if (lensSelect.value === matchingLensOption.value) return;
      lensSelect.value = matchingLensOption.value;
      lensSelect.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }
    kb.addEventListener('change', event => {
      const { caseSelect } = getSelectors();
      if (event.target === caseSelect) {
        setTimeout(syncLensToCase, 50);
      }
    });
    kb.addEventListener('variant-selected', () => {
      setTimeout(syncLensToCase, 50);
    });
    setTimeout(syncLensToCase, 250);
  }
  initKachingLensSync();
})();